import Glide from "@glidejs/glide";
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["slider"];

  connect() {
    this.createGlide();
    window.addEventListener("resize", this.resizeHandler.bind(this));
  }

  resizeHandler() {
    this.glide.destroy();
    this.createGlide();
  }

  createGlide() {
    const sliders = this.sliderTarget.querySelectorAll(".glide__slide");
    if (sliders.length === 0) {
      return;
    }

    if (window.innerWidth >= 1200) {
      this.glide = new Glide(this.sliderTarget, {
        type: sliders.length > 1 ? "carousel" : "slider",
        startAt: 0,
        perView: 2.65,
        focusAt: 'center',
        gap: -50,
        swipeThreshold: 5,
        dragThreshold: 5
      }).mount();
    } else if (window.innerWidth >= 900 && window.innerWidth < 1200) {
      this.glide = new Glide(this.sliderTarget, {
        type: sliders.length > 1 ? "carousel" : "slider",
        startAt: 0,
        perView: 2.65,
        focusAt: 'center',
        gap: -40,
        swipeThreshold: 5,
        dragThreshold: 5
      }).mount();
    } else {
      this.glide = new Glide(this.sliderTarget, {
        type: sliders.length > 1 ? "carousel" : "slider",
        startAt: 0,
        perView: 1.21,
        focusAt: 'center',
        gap: -40,
        swipeThreshold: 5,
        dragThreshold: 5
      }).mount();
    }
  }

  disconnect() {
    this.glide.destroy();
    window.removeEventListener("resize", this.resizeHandler);
  }
}
